module.exports = __webpack_public_path__ + "img/arupcompute.a7e78824.png";